import {InsurerId} from '../../Config/dataModel';
import {request} from './request';

const qrCode = (ref: string, data: InsurerId) => {
    return request({
        url: `/qrCode/get/${ref}`,
        method: 'PUT',
        data
    });
};

const qrCodeAPI = {qrCode};

export default qrCodeAPI


// WEBPACK FOOTER //
// ./src/ReduxRequests/APIs/qrCodeAPI.ts